// extracted by mini-css-extract-plugin
module.exports = {"errTxt":"styles_errTxt__cwLcn"};